<template>
	<div
		class="g-block-body-bullet g-block-body-padding"
		:class="{
			'g-block-body-bullet--edit': editable,
			'is-active': editable && active,
			'g-block-body-bullet--h5': h5,
			'g-block-body-padding--h5': h5,
		}"
		@click="onWrapClick"
	>
		<div class="g-block-body-bullet__row">
			<span
				class="g-block-body-bullet__dot"
				:style="{ background: dotColor }"
				aria-hidden="true"
			></span>
			<RichTextEditable
				v-if="editable"
				class="g-block-body-bullet__text"
				:model-value="data.content"
				placeholder="请输入正文"
				@update:model-value="onContentUpdate"
				@focus="onWrapClick"
			/>
			<div
				v-else
				class="g-block-body-bullet__text"
				v-html="data.content || ''"
			></div>
		</div>
	</div>
</template>

<script>
	import RichTextEditable from '../../../components/RichTextEditable.vue';
	import { getTitleThemeColor } from '../../../templates.js';
	import { bodyMixin } from '../shared/bodyMixin.js';

	export default {
		name: 'GBlockBodyBullet',
		components: { RichTextEditable },
		mixins: [bodyMixin],
		computed: {
			dotColor() {
				return getTitleThemeColor(this.data);
			},
		},
	};
</script>

<style scoped lang="less">
	@import '../shared/bodyEditShell.less';

	.g-block-body-bullet {
		.body-block-edit-shell();
	}

	.g-block-body-bullet__row {
		display: flex;
		align-items: flex-start;
		gap: 8px;
	}

	.g-block-body-bullet__dot {
		flex-shrink: 0;
		width: 6px;
		height: 6px;
		margin-top: 8px;
		border-radius: 50%;
	}

	.g-block-body-bullet__text {
		.body-text-base();
		flex: 1;
		min-width: 0;
	}

	.g-block-body-bullet--h5 {
		.g-block-body-bullet__row { gap: 0.16rem; }
		.g-block-body-bullet__dot {
			width: 0.12rem;
			height: 0.12rem;
			margin-top: 0.16rem;
		}
		.body-text-base--h5(~'.g-block-body-bullet__text');
	}
</style>
